import React, { useState } from 'react';
import { makeStyles, ThemeProvider, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';

import Topbar from './Topbar.jsx';
import Sidebar from './Sidebar.jsx';
import HelpCenter from './HelpCenter.jsx';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  // necessary for content to be below app bar
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    position: 'absolute',
    top: '65px',
    bottom: '0px',
    left: '260px',
    right: '0px',
    overflowy: 'auto',
  },
  paper: {
    height: 'calc(100% - 64px)',
    top: '64px',
    boxShadow: 'none',
    borderTop: () =>
      theme.palette.type === 'dark'
        ? '1px solid rgba(256, 256, 256, 0.12)'
        : '1px solid rgba(0, 0, 0, 0.12)',
    borderLeft: () =>
      theme.palette.type === 'dark'
        ? '1px solid rgba(256, 256, 256, 0.12)'
        : '1px solid rgba(0, 0, 0, 0.12)',
  },
}));

const MainLayout = ({ apiToken, setApiToken, setColorTheme, window, mode, filters, ...props }) => {
  const classes = useStyles();
  const theme = useTheme();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [state, setState] = React.useState({
    right: false,
  });
  const isMobile = useMediaQuery((mqTheme) => mqTheme.breakpoints.down('xs'));

  const container = window !== undefined ? () => window().document.body : undefined;

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const toggleDrawer = (anchor, open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setState({ ...state, [anchor]: open });
  };

  return (
    <div className={classes.root}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Topbar
          handleDrawerToggle={handleDrawerToggle}
          apiToken={apiToken}
          setApiToken={setApiToken}
          setColorTheme={setColorTheme}
          isMobile={isMobile}
          mode={mode}
          filters={filters}
        />
        <Sidebar
          type="ADMIN"
          apiToken={apiToken}
          mobileOpen={mobileOpen}
          handleDrawerToggle={handleDrawerToggle}
          handleToggleDrawer={toggleDrawer}
          isMobile={isMobile}
          setApiToken={setApiToken}
          setColorTheme={setColorTheme}
        />
        <main className={classes.content}>{props.children}</main>
        <Drawer
          anchor="right"
          container={container}
          open={state.right}
          onClose={toggleDrawer('right', false)}
          classes={{ paper: classes.paper }}
          BackdropProps={{ invisible: true }}
        >
          <HelpCenter handleClose={toggleDrawer('right', false)} />
        </Drawer>
      </ThemeProvider>
    </div>
  );
};

export default MainLayout;
